import { Button, Link, Paper, Stack, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { CookieConsent, getCookieConsent, setCookieConsent } from '../utils/cookieConsent';

export default function CookieBanner() {
  // Only decide whether to show the banner after mount to avoid hydration mismatches
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setOpen(getCookieConsent() === null);
  }, []);

  if (!open) return null;

  const choose = (consent: CookieConsent) => {
    setCookieConsent(consent);
    setOpen(false);
  };

  return (
    <Paper
      role="region"
      aria-label="Cookie consent"
      elevation={6}
      sx={{
        position: 'fixed',
        bottom: 16,
        left: 16,
        right: 16,
        maxWidth: 600,
        mx: 'auto',
        p: 2,
        zIndex: (theme) => theme.zIndex.snackbar,
      }}
    >
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems="center">
        <Typography variant="body2" sx={{ flex: 1 }}>
          We use optional analytics cookies to understand how this site is used and to improve it.
          They are only set if you accept. See our{' '}
          <Link href="https://cogs.show/privacy" target="_blank" rel="noopener">
            privacy policy
          </Link>
          .
        </Typography>
        <Stack direction="row" spacing={1} flexShrink={0}>
          <Button variant="outlined" onClick={() => choose('denied')}>
            Reject
          </Button>
          <Button variant="contained" onClick={() => choose('granted')}>
            Accept
          </Button>
        </Stack>
      </Stack>
    </Paper>
  );
}
